import React from 'react';
import { reviews } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Reviews = () => {
  return (
    <section className="py-20 bg-slate-100 border-y border-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center space-x-4 mb-12">
          <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tight">Field Tested</h2>
          <div className="flex-grow h-px bg-gray-300"></div>
          <div className="flex items-center space-x-1 text-slate-900 font-bold">
            <span className="text-2xl">4.8</span>
            <SafeIcon icon={FiIcons.FiStar} className="text-lime-500 fill-current" />
            <span className="text-sm text-gray-500 font-normal">/ 5.0 Average</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map(review => (
            <div key={review.id} className="bg-white p-6 border-l-4 border-lime-400 shadow-sm relative">
              <SafeIcon icon={FiIcons.FiMessageSquare} className="absolute top-4 right-4 text-gray-100" size={40} />
              <div className="flex space-x-1 mb-3 relative z-10">
                {[...Array(5)].map((_, i) => (
                  <SafeIcon key={i} icon={FiIcons.FiStar} className={i < review.rating ? "text-lime-500 fill-current" : "text-gray-300"} size={16} />
                ))}
              </div>
              <p className="text-slate-700 italic mb-4 relative z-10">"{review.text}"</p>
              <div className="mt-auto relative z-10">
                <p className="font-bold text-slate-900 uppercase text-sm">{review.name}</p>
                <p className="text-xs text-gray-500 font-medium mt-1">Verified Buyer • {review.tool}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;